import React from 'react';

import ReportSummary2 from '../../components/report-summary2';
import ReportHeroContent from '../../components/report-hero-content';
import ReportSupportingActivity2 from '../../components/report-supporting-activity2';
import ReportHeader from '../../components/report-header';
import Transformer from './transformer';

const HeroReport = ({ data }) => {
  const reportData = data.data;
  return (
    <div>
      <ReportHeader info={Transformer.getInfoSection(reportData)} />
      <ReportHeroContent
        mainData={Transformer.getHeroData(reportData)}
        heroPost={Transformer.getHeroPost(reportData)}
      />
      <ReportSupportingActivity2
        posts={Transformer.getSupportingActivity(reportData)}
        info={Transformer.getInfoSection(reportData)}
      />

      <ReportSummary2 data={Transformer.getSummaryData(reportData)} />

    </div>
  );
};

export default HeroReport;



// WEBPACK FOOTER //
// ./src/components/hero-report/index.js